/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const UPDATE_DISPLAYS_ORDER = gql`
  mutation UpdateDisplaysOrder(
    $filters: DisplayFilter!
    $data: [DisplaysOrderInput!]!
  ) {
    updateDisplaysOrder(filters: $filters, data: $data) {
      id
      order
    }
  }
`
